<hdmui-base-dialog
  dialogIcon="hdmui:info"
  dialogTitle="{{ '*.about' | translate }}"
  [dialogOptions]="option"
  [closeInHeaderVisible]="false"
  (okClicked)="onOk()"
  (cancelClicked)="onCancel()"
>
  <mat-dialog-content>
    <div class="container-fluid p-0">
      <div class="row m-0">
        <div class="col-sm-12 image-background app-icon">
          <mat-icon
            svgIcon="app:deviceAdministrationApp"
            style="display: inline"
          ></mat-icon>
        </div>
        <div class="col-sm-12">
          <h1>{{ data.appName }}</h1>
        </div>
        <div class="col-sm-12">
          <p class="small">{{ data.copyright }}</p>
        </div>
      </div>
    </div>
  </mat-dialog-content>
</hdmui-base-dialog>
